export default __webpack_public_path__ + "static/media/tool_R4a_form.ea0b9e4c.pdf";